class FrontendLogger {
  private isDevelopment: boolean;

  constructor() {
    this.isDevelopment = import.meta.env.MODE === 'development';
  }

  private shouldLog(): boolean {
    return this.isDevelopment;
  }

  debug(message: any, ...args: any[]): void {
    if (this.shouldLog()) {
      console.log(`[DEBUG] ${message}`, ...args);
    }
  }

  info(message: any, ...args: any[]): void {
    if (this.shouldLog()) {
      console.info(`[INFO] ${message}`, ...args);
    }
  }

  warn(message: any, ...args: any[]): void {
    if (this.shouldLog()) {
      console.warn(`[WARN] ${message}`, ...args);
    }
  }

  error(message: any, ...args: any[]): void {
    // Always log errors, but with less detail in production
    if (this.isDevelopment) {
      console.error(`[ERROR] ${message}`, ...args);
    } else {
      console.error('[ERROR] An error occurred');
    }
  }

  // API request/response logging - only in development
  api(method: string, url: string, data?: any): void {
    if (this.shouldLog()) {
      console.log(`[API] ${method.toUpperCase()} ${url}`, data || '');
    }
  }

  // Auth-related logging - never log sensitive data in production
  auth(message: string, data?: any): void {
    if (this.shouldLog()) {
      console.log(`[AUTH] ${message}`, data || '');
    }
  }

  // Component lifecycle logging
  component(componentName: string, action: string, data?: any): void {
    if (this.shouldLog()) {
      console.log(`[${componentName.toUpperCase()}] ${action}`, data || '');
    }
  }
}

export const logger = new FrontendLogger();
export default logger;
